import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=49750741"
import script from "./EditProfileForm.js?vue&type=script&lang=js&external"
export * from "./EditProfileForm.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports